import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { LEADERSHIP } from "@/lib/data";

export default function Leadership() {
  return (
    <section
      id="lideranca"
      data-testid="leadership-section"
      className="bg-[#050505] py-24 sm:py-32 border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="max-w-3xl mb-16">
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
            className="text-xs tracking-overline uppercase text-[#D4AF37] mb-6"
          >
            Nossa Liderança
          </motion.p>
          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            data-testid="leadership-title"
            className="font-serif-display text-4xl sm:text-5xl lg:text-6xl text-white leading-[1.05] tracking-tight"
          >
            Servos chamados <span className="italic text-white/80">para</span>{" "}
            <span className="text-[#D4AF37]">pastorear</span>.
          </motion.h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">
          {LEADERSHIP.map((l, idx) => (
            <motion.div
              key={l.name}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: idx * 0.1 }}
              data-testid={`leader-card-${idx}`}
            >
              <Link
                to={`/lideranca#${l.name.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9\s-]/g, '').replace(/\s+/g, '-')}`}
                className="group relative aspect-[3/4] overflow-hidden bg-[#0A0A0A] block"
              >
                <img
                  src={l.image}
                  alt={l.name}
                  className="absolute inset-0 w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-700 scale-105 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/95 via-black/40 to-transparent" />
                <div className="absolute bottom-0 left-0 right-0 p-6">
                  <p className="text-[10px] tracking-overline uppercase text-[#D4AF37] mb-2">
                    {l.role}
                  </p>
                  <h3 className="font-serif-display text-2xl text-white leading-tight">
                    {l.name}
                  </h3>
                  {l.partner && (
                    <p className="mt-2 text-sm italic text-white/65">
                      com {l.partner}
                    </p>
                  )}
                  <p className="mt-3 text-xs text-[#D4AF37] uppercase tracking-wider opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    Clique para conhecer mais
                  </p>
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
